import type { ReactElement } from "react";
import { Card } from "../../ui/Card/Card";
import { Badge } from "../../ui/Badge/Badge";
import { avatarColor, avatarInitials } from "../../lib/avatar";
import { useIdentity, useMeUser } from "../../lib/user";
import { useAuth } from "../../lib/auth/use-auth";
import { DefinitionRow } from "./DefinitionRow";
import styles from "./ProfileCard.module.css";

export function ProfileCard({
  compact = false,
}: {
  compact?: boolean;
}): ReactElement {
  const identity = useIdentity();
  const user = useMeUser();
  const auth = useAuth();
  const pfId = auth.claims?.sub ?? "—";
  const status = user ? (
    <Badge tone={user.status === "active" ? "success" : "neutral"}>
      {user.status === "active" ? "Active" : "Inactive"}
    </Badge>
  ) : (
    "—"
  );

  return (
    <Card>
      <div className={styles.header}>
        <span
          className={`${styles.avatar} ${compact ? styles.avatarSm : ""}`}
          style={{ background: avatarColor(identity) }}
          aria-hidden="true"
        >
          {avatarInitials(identity)}
        </span>
        <div>
          <h2 className={`${styles.name} ${compact ? styles.nameSm : ""}`}>
            {identity.name}
          </h2>
          <p className={styles.email}>{identity.email}</p>
        </div>
      </div>

      <div className={styles.divider} />

      {compact ? (
        <div className={styles.rows}>
          <DefinitionRow label="Property Finder ID">{pfId}</DefinitionRow>
          <DefinitionRow label="Account status">{status}</DefinitionRow>
        </div>
      ) : (
        <div className={styles.grid}>
          <DefinitionRow label="Property Finder ID" variant="stacked">
            {pfId}
          </DefinitionRow>
          <DefinitionRow label="Account status" variant="stacked">
            {status}
          </DefinitionRow>
        </div>
      )}
    </Card>
  );
}
